import { PasswordsType } from '../types';
import { changePassword } from '../services';
import { mapPasswords } from '../utils';

export const onSubmitPasswords = (values: PasswordsType) => {
  changePassword(mapPasswords(values))
};
